/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getFooter } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getWidgetsByPageId } from "@insite/client-framework/Store/Data/Widgets/WidgetSelectors";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import MarketoFormWrapper from "@stoneage/App/Components/MarketoFormModal/MarketoFormWrapper";
import { getMarketoSettings } from "@stoneage/App/Store/Selectors/MarketoSettings";
import React from "react";
import { useDispatch } from "react-redux";
import { css } from "styled-components";

export interface MarketoCustomModalStyles {
    modal?: InjectableCss;
}

export const styles: MarketoCustomModalStyles = {
    modal: {
        css: css`
            display: none; /* Hidden by default */
        `,
    },
};

type OwnProps = {
    widgetId: string;
};

type Props = OwnProps;

const MarketoCustomModal = ({ widgetId }: Props) => {
    const dispatch = useDispatch();
    const { formIds } = useAppSelector(state => {
        const widgetFields = getWidgetsByPageId(state, getFooter(state).id).find((widget: WidgetProps) => {
            return widget.type === "MarketoForm/MarketoFormInitializer";
        })?.fields;
        let marketoIds = [];

        if (widgetFields && widgetFields?.formIds && widgetFields?.formIds?.length > 0) {
            marketoIds = widgetFields.formIds.split(",");
        }
        return {
            formIds: marketoIds,
            marketoSettings: getMarketoSettings(state),
        };
    });

    return (
        // This component is just a hidden placeholder to be detected by 
        // MarketoFormInitalizer Widget so it can render Marketo Forms
        <StyledWrapper {...styles.modal}>
            {formIds.map((formId: string, index: number) => {
                return (
                    <MarketoFormWrapper
                        key={`${index}_${formId}`}
                        formId={formId}
                        inModal={true}
                        onUuidGenerate={(uuid: string) => {
                            // Set uuid & formId for created forms inside the modals
                            dispatch({ type: "MarketoForm/SetModalForm", formId, uuid });
                        }}
                        useRenderFunction={false}
                    />
                );
            })}
        </StyledWrapper>
    );
};

export default MarketoCustomModal;
